import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingAutomationRule.Delete.IRequest;
type Response = Api.Core.ProductPricingAutomationRule.Delete.IResponse;
type Headers = Api.Core.ProductPricingAutomationRule.Delete.IHeaders;
const url = '/api/ProductManagement/ProductPricingAutomationRule/:id';
export default async function productPricingAutomationRuleDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
